"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = __importDefault(require("react"));
var AuthMenu_1 = require("./AuthMenu");
var NotAuthMenu_1 = require("./NotAuthMenu");
var SearchButton_1 = __importDefault(require("./SearchButton"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var RightMenu = function (_a) {
    var isNarrowXl = _a.isNarrowXl, isNotFoundPage = _a.isNotFoundPage, languages = _a.languages, withReferral = _a.withReferral, textVariant = _a.textVariant, changeLanguageVariant = _a.changeLanguageVariant;
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.authContainer }, Object.keys(breakpoints).length > 0 &&
        (breakpoints.mobile || breakpoints.tablet ? (react_1.default.createElement(react_1.default.Fragment, null, !isNotFoundPage && react_1.default.createElement(SearchButton_1.default, null))) : isAuth ? (react_1.default.createElement(AuthMenu_1.AuthMenu, { isNarrowXl: isNarrowXl, languages: languages, withReferral: withReferral, changeLanguageVariant: changeLanguageVariant })) : (react_1.default.createElement(NotAuthMenu_1.NotAuthMenu, { isNarrowXl: isNarrowXl, languages: languages, textVariant: textVariant, changeLanguageVariant: changeLanguageVariant })))));
};
exports.default = react_1.default.memo(RightMenu);
